import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategoryStrip from "./components/CategoryStrip";
import Featured from "./components/Featured";
import Ranking from "./components/Ranking";
import FeatureModes from "./components/FeatureModes";
import Faq from "./components/Faq";
import Cta from "./components/Cta";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    { "@type": "Question", name: "漫画岛支持哪些阅读模式?", acceptedAnswer: { "@type": "Answer", text: "漫画岛支持滚动阅读、翻页阅读和双页横屏三种主要阅读模式,可在阅读页面随时切换。" } },
    { "@type": "Question", name: "如何开启横屏观看高清原图?", acceptedAnswer: { "@type": "Answer", text: "进入阅读界面后旋转设备至横屏,即可自动切换到横屏高清模式,放大呈现每一格画面细节。" } },
    { "@type": "Question", name: "夜间模式在哪里设置?", acceptedAnswer: { "@type": "Answer", text: "点击页面右上角的月亮图标即可一键切换夜间模式,夜间追漫更护眼不累眼。" } },
    { "@type": "Question", name: "长时间追漫会累眼吗?", acceptedAnswer: { "@type": "Answer", text: "漫画岛通过夜间模式、舒适的翻页动效和可调节设置,尽可能减少长时间阅读带来的视觉疲劳。" } },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryStrip />
        <Featured />
        <Ranking />
        <FeatureModes />
        <Faq />
        <Cta />
      </main>
      <Footer />
    </>
  );
}